// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1QkeN","sendOtp":"AuthorizeToLogin_sendOtp__55YsG"};